import React from "react";
import { Table } from "@dossier/salvia-ui";

export default function MinibeakResult() {
  return (
    <>
      <Table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <code>data</code>
            </td>
            <td>Resource or array of resources</td>
            <td>The resource or resources returned directly by the call.</td>
          </tr>
          <tr>
            <td>
              <code>resources</code>
            </td>
            <td>Map of resource types to maps of resource ids to resources</td>
            <td>
              All of the resources returned by the call, including included
              resources.
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
}
